if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"eguardian_dashboard","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2063|5671|7139|9033)$/.test(chunkId)},
		rootOutputDir: "../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}